<template>
  <div>
    <div class="flex border-b border-gray-200 py-3 justify-between">
      <div class="flex flex-col">
        <h5 class="text-gray-700 text-sm py-2 font-bold uppercase">
          Playlist List
        </h5>
      </div>
      <router-link :to="{ name: 'ChannelCreatePlaylistPage', params: { channelId: this.channelId }}">
        <a  class="text-sm focus:outline-none px-4 py-2 rounded font-bold cursor-pointer
                          hover:bg-blue-700 hover:text-blue-100
                          text-blue-700
                            border duration-200 ease-in-out
                          border-blue-600 transition">Create Playlist</a>
      </router-link>
    </div>
    <div class="flex py-3">
      <div class="w-full p-3">
        <el-table-draggable @sort="onSort"  handle=".handle-move" >
          <el-table :data="data" row-key="id" :show-header="false" style="width: 100%">
            <el-table-column label="Handle" align="center" key="handle">
              <div class="static inline-block text-center container-action handle-move" style="cursor: move">
                <font-awesome-icon size="2x" :icon="['fa', 'th']" />
              </div>
            </el-table-column>
            <el-table-column label="Cover" key="cover">
              <template slot-scope="scope">
                <div class="static inline-block text-center container-action">
                  <img :src="scope.row.thumbnail" style="width: 100px;object-fit: cover" />
                </div>
              </template>
            </el-table-column>
            <el-table-column v-for="column in tableColumn" :prop="column.prop" :label="column.label" :key="column.prop" sortable="custom">
            </el-table-column>
            <el-table-column label="Last Modified" key="lastmod" width="200px">
              <template slot-scope="scope">
                <div class="static inline-block text-center container-action">
                  <span>Last Modified:</span>
                  <br />
                  <span>{{ scope.row.modified_at }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Actions" align="right">
              <template slot-scope="scope">
                <div class="static inline-block text-left container-action">
                  <VueCustomTooltip label="Edit" :position="'is-left'">
                    <router-link :to="{ name: 'ChannelEditPlaylistPage', params: { channelId: channelId,  id: scope.row.id }}">
                      <button type="button"  class="p-2 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none" >
                        <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                      </button>
                    </router-link>
                  </VueCustomTooltip>
                  <VueCustomTooltip label="Delete" :position="'is-left'">
                    <button @click="deletePlaylist(scope.row)" class="p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                    </button>
                  </VueCustomTooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Toggle" class="text-center" >
              <template slot-scope="scope">
                <label
                  :for="'tooglepl'+scope.row.id"
                  class="flex items-center"
                  :class="'cursor-pointer'"
                  style="height: 50px;"
                >
                  <!-- toggle -->
                  <div class="relative m-auto">
                    <!-- input -->
                    <input
                      :id="'tooglepl'+scope.row.id"
                      v-model="scope.row.status"
                      @change="setStatusPlaylist(scope.row)"
                      type="checkbox"
                      class="hidden"
                    />
                    <!-- line -->
                    <div
                      class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                    ></div>
                    <!-- dot -->
                    <div
                      class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                    ></div>
                  </div>
                  <!-- label -->
                </label>
              </template>
            </el-table-column>
          </el-table>
        </el-table-draggable>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import ElTableDraggable from 'el-table-draggable';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import Vue from 'vue';
import { Button } from '@/components/Layout/Form';

export default {
  name: 'TabPlaylist',
  props: {
    channel: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      channelId: Number(this.$route.params.channelId),
      utc_offset: Math.floor(moment().utcOffset() / 60),
      tableColumn: [
        {
          prop: 'name',
          label: 'Title',
        },
        {
          prop: 'total_videos',
          label: 'Videos',
        },
        {
          prop: 'total_watch',
          label: 'Plays',
        },
      ],
      data: [],
    }
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isOps', 'isFinance']),
    ...mapGetters('MissionsVideosModule', ['listPlaylist']),
  },
  watch: {
    listPlaylist: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.refineData();
      },
    },
  },
  async mounted() {
    await this.requestGetPlaylists({
      id: this.channelId
    });
  },
  methods: {
    ...mapActions('MissionsVideosModule', ['requestGetPlaylists','requestReOrderPlaylist', 'requestDeletePlaylist', 'requestSetStatusPlaylist']),
    refineData() {
      if (this.listPlaylist) {
        this.data = this.listPlaylist.map((pl) => {
          return {
            ...pl,
            total_videos: pl.total_videos + ' Videos',
            total_watch: pl.total_watch + ' Plays',
            // duration: this.secToMinFormat(videos.duration),
            // category_name: categories,
            // type: videos.type === 'podcast' ? 'Podcast' : 'Mission',
            modified_at: moment(pl.updated_at)
              .format('YYYY-MM-DD HH:mm:ss'),
          };
        });
      }
    },
    async onSort(evt) {
      setTimeout(async () => {
        const ids = this.data.map(play => play.id);
        await this.requestReOrderPlaylist({
          channel_id: this.channelId,
          ids,
        });
      }, 500);
    },
    async deletePlaylist(playlist) {
      Vue.swal({
        title: 'Delete Data!',
        text: `Are you sure to delete playlist: ${playlist.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestDeletePlaylist({
            id: playlist.id,
            channel_id: this.channelId,
          });
          this.$swal('Deleted', `You successfully delete playlist: ${playlist.name}`, 'success');
        }
      });
    },
    async setStatusPlaylist(playlist) {
      const status = {
        id: playlist.id,
        channel_id: this.channelId,
        status: playlist.status,
      };
      await this.requestSetStatusPlaylist(status);
    },
  },
  components:{
    ElTableDraggable, VueCustomTooltip, Button
  }
}
</script>

<style scoped>
.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #48bb78;
}
</style>



// WEBPACK FOOTER //
// src/views/MissionsVideos/Channel/TabPlaylist.vue